import type { Transcription } from './contrat.js';
import type { SaisieEntretien } from './entretien.js';
import { REFERENTIEL_ACCUEIL } from './referentiel.js';

export interface CompteRendu {
  statut: 'a_verifier' | 'relu';
  texte: string;
}

const NON_RENSEIGNE = 'non renseigné';

/** Compte rendu généré depuis le vocal transcrit (#31, RG-26) : toujours « à vérifier » (RG-19). */
export function genererCompteRendu(transcription: Transcription, saisie: SaisieEntretien): CompteRendu {
  const type = REFERENTIEL_ACCUEIL.types.find((t) => t.code === saisie.typeDemande)?.libelle ?? NON_RENSEIGNE;
  const texte = [
    'Compte rendu de l’entretien d’accueil',
    `Objet de la demande : ${type}`,
    `Propriétaire d’origine : ${saisie.proprietaireOrigine.trim() || NON_RENSEIGNE}`,
    `Date de naissance du propriétaire d’origine : ${saisie.dateNaissanceProprietaire.trim() || NON_RENSEIGNE}`,
    '',
    transcription.text,
    '',
    'À vérifier : compte rendu généré automatiquement, à relire avant tout usage.',
    'Cabinet MAAT',
  ].join('\n');
  return { statut: 'a_verifier', texte };
}
